import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { CustomValidators } from 'ng2-validation';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router} from '@angular/router';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
import { NgClass, NgStyle} from '@angular/common';
import { HttpModule, Http } from '@angular/http';
import { FileSelectDirective, FileDropDirective, FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { httpservice } from 'http/http';

import { environment } from 'environments/environment.prod';
import { isArray } from 'util';

const breadcrumb: any[] = [
  {
    title: 'Home'
   
  },
  {
    title: 'Material'

  },
  {
    title: 'Add material'

  }
];

//const password = new FormControl('', Validators.required);
//const confirmPassword = new FormControl('', CustomValidators.equalTo(password));

@Component({
  selector: 'page-material-form-add',
  templateUrl: './material-form-add.html',
  styleUrls: ['./material-form-add.scss']
  
})


export class PageMaterialAdd implements OnInit {
  pageTitle: string = environment.sysName;
  breadcrumb: any[] = breadcrumb;
  public form: FormGroup;
  selectcustomer: any;
  stateCtrl: FormControl;
  filteredStates:any;
  filteredPartnos:any;
  data: any;
  
  fd:FormData;
  supplierStr: string;
  unitStr: string;
  colorStr: string;
  typeStr: string;
  message:string;
  catalogStr:string;
  minStr:string;
  maxStr: string;
  priceStr:string;
  lotsizeStr:string;
  weightStr:string;
  cuttingStr:string;
  lengthStr:string;

  sourceStr:string;
  statusStr:string;

  //diaglog
  dialogRef: MdDialogRef<MaterailDiableDialogAdd>;
  selectedOption: string;

  types = [
    { value: 'PT', viewValue: 'PT' },
    { value: 'Part', viewValue: 'Part' },
    { value: 'RM', viewValue: 'RM' }
  ];

  groups = [
    { value: 'N/A', viewValue: 'N/A' },
    { value: 'Current', viewValue: 'Current' },
    { value: 'Service', viewValue: 'Service' },
    { value: 'New Model', viewValue: 'New Model' },
    { value: 'Dead Stock', viewValue: 'Dead Stock' },
  ];

  units = [
    { value: 'Pcs', viewValue: 'Pcs' },
    { value: 'Kg', viewValue: 'Kg' },
    { value: 'g', viewValue: 'g' },
    { value: 'Cm', viewValue: 'Cm' },
    { value: 'm', viewValue: 'm' },
    { value: 'mm', viewValue: 'mm' },
    { value: 'Can', viewValue: 'Can' },
    { value: 'Box', viewValue: 'Box' },
    { value: 'Roll', viewValue: 'Roll' },
    { value: 'Sheet', viewValue: 'Sheet' },
    { value: 'Blade', viewValue: 'Blade' }
  ];

  colors = [
    { value: 'N/A', viewValue: 'N/A' },
    { value: 'RED', viewValue: 'RED' },
    { value: 'BLACK', viewValue: 'BLACK' },
    { value: 'BLUE', viewValue: 'BLUE' }
  ];

  sources = [
    { value: 'N/A', viewValue: 'N/A' },
    { value: 'Service CKD', viewValue: 'Service CKD' },
    { value: 'Service LS', viewValue: 'Service LS' },
    { value: 'CKD', viewValue: 'CKD' },
    { value: 'LS', viewValue: 'LS' },
    { value: 'Plating parts', viewValue: 'Plating parts' },
    { value: 'SUB ASSY', viewValue: 'SUB ASSY' },
    { value: 'WIP(CU)', viewValue: 'WIP(CU)' },
    { value: 'WIP(PRESS)', viewValue: 'WIP(PRESS)' },
    { value: 'WIP(SP)', viewValue: 'WIP(SP)' },
    { value: 'WIP(TC)', viewValue: 'WIP(TC)' }
  ];

  suppliers = [];
  catalogs =[];
  partnos=[];

  //upload file
  imageSrc:any;
  urlApi=environment.url+"/api/uploadToserver.php";
  //uploader:any;
  Name:string; 
  myFile:File; /* property of File type */
  //end upload file
  supplierCtrl:FormControl;
  filteredSupplier:any;
  key:any="";
  constructor(
    private httpservice:httpservice,
    public http:Http,
    public dialog: MdDialog,
    private fb: FormBuilder,
    private _sharedService: SharedService,
    private router: Router) {
    this.getSupplier();
    this._sharedService.emitChange(this.pageTitle);
  }


  getSupplier(){
    this.httpservice.fetchget('getJSON_supplier_name.php?',(supplier) => {
      this.suppliers = supplier.map(function (val) {
        return [val.tb2_company_shortname];
      });
      //console.log('------this.supplier------', this.suppliers);
    });
    this.supplierCtrl = new FormControl();
    this.filteredSupplier = this.supplierCtrl.valueChanges
    .startWith(null)
    .map(val => {
      if (isArray(val)) {
        this.key = val[0];
        //this.poCtrl.setValue(val[0]);
      } else {
        this.key = val;
        //this.poCtrl.setValue(val);
      }
      console.log('------val------',this.key);
         return val ? this.suppliers.filter((s) => new RegExp(val, 'gi').test(s)) : this.suppliers;
    });
  }


    openDialog() {

    let dialogRef = this.dialog.open(MaterailDiableDialogAdd);
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      
      if(result==='1'){
        this.postString();
        //console.log('---result---',result);
       // alert('postString');
      }else{
        //console.log('---result---',result);
       // alert('cancel');
      }

    });
  }

    fetchCatalog(cb) {
    const req = new XMLHttpRequest();
    req.open('GET',  environment.url+'/api/getJSON_material_catalog.php');

    req.onload = () => {
      cb(JSON.parse(req.response));
    };

    req.send();
  }

  filterStates(val: string) {
    this.supplierStr  = val;
    //console.log('customerStr : ',this.supplierStr);
    return val ? this.suppliers.filter((s) => new RegExp(val, 'gi').test(s)) : this.suppliers;
  }

  filterPartno(val: string) {
    //this.partStr  = val;
    //console.log('customerStr : ',val);
    return val ? this.partnos.filter((s) => new RegExp(val, 'gi').test(s)) : this.partnos;
  }

  onChange(type: string) {
    alert(type);
  }

  checkExist(){
    
    //alert(this.form.controls.partno.value);
    const req = new XMLHttpRequest();
    req.open('GET',  environment.url+'/api/getJSON_check_material_exist.php?partno='+this.form.controls.partno.value);

    req.onload = () => {

      //console.log('status--',JSON.parse(req.response));
      if(!JSON.parse(req.response).error){
       // alert("THIS PARTNO EXIST"+this.form.controls.partno.value);

        let dialogRef = this.dialog.open(MaterailDiableDialogExist);
        let instance = dialogRef.componentInstance;
        instance.Message=this.form.controls.partno.value+" : EXIST!";
        instance.Title="System Message"
      }else{
        //alert('Exist'+this.form.controls.partno.value);
      }
    };

    req.send();


    

  }

  fetchSupplier(cb) {
    const req = new XMLHttpRequest();
    req.open('GET',  environment.url+'/api/getJSON_supplier_name.php');

    req.onload = () => {
      cb(JSON.parse(req.response));
    };

    req.send();
  }

  fetchPartno(cb) {
    const req = new XMLHttpRequest();
    req.open('GET',  environment.url+'/api/getJSON_material_model.php');
    req.onload = () => {
      cb(JSON.parse(req.response));
    };
    req.send();
  }

  postString() {
    let filename;

    if(this.myFile!=null){
      filename = this.myFile.name;
    }
    let value = {
      length:this.lengthStr,
      cutting:this.cuttingStr,
      filename:filename,
      status:this.statusStr,
      source:this.sourceStr,
      weight:this.weightStr,
      catalog:this.catalogStr,
      lotsize:this.form.controls.lotsize.value,
      supplier:this.key,
      unit:this.unitStr,
      color:this.colorStr,
      model:this.form.controls.model.value,
      partname:this.form.controls.partname.value,
      partno:this.form.controls.partno.value,
      max:this.form.controls.max.value,
      min:this.form.controls.min.value,
      spec:this.form.controls.spec.value,
      price:this.form.controls.price.value,
      type:this.typeStr
    }

    this.httpservice.fetchpost('insertDataMaterial.php',value,cb=>{
      console.log('data',value,cb)
    })
    
    // if(this.myFile!=null){
    //   //this.data = "length="+this.lengthStr+"&cutting="+this.cuttingStr+"&filename="+this.myFile.name+"&status="+this.statusStr+"&source="+this.sourceStr+"&weight="+this.weightStr+"&catalog="+this.catalogStr+"&lotsize="+this.form.controls.lotsize.value+"&supplier="+this.supplierStr+"&unit=" + this.unitStr + "&color=" + this.colorStr + "&model=" + this.form.controls.model.value + "&partname=" + this.form.controls.partname.value + "&partno=" + this.form.controls.partno.value + "&max=" + this.form.controls.max.value + "&min=" + this.form.controls.min.value + "&spec=" + this.form.controls.spec.value + "&price=" + this.form.controls.price.value + "&type=" + this.typeStr;
    // }else{
    //   this.data = "length="+this.lengthStr+"&cutting="+this.cuttingStr+"&status="+this.statusStr+"&source="+this.sourceStr+"&weight="+this.weightStr+"&catalog="+this.catalogStr+"&lotsize="+this.form.controls.lotsize.value+"&supplier="+this.supplierStr+"&unit=" + this.unitStr + "&color=" + this.colorStr + "&model=" + this.form.controls.model.value + "&partname=" + this.form.controls.partname.value + "&partno=" + this.form.controls.partno.value + "&max=" + this.form.controls.max.value + "&min=" + this.form.controls.min.value + "&spec=" + this.form.controls.spec.value + "&price=" + this.form.controls.price.value + "&type=" + this.typeStr;
    // }
   
    // const req = new XMLHttpRequest();
    // req.open('POST',  environment.url+'/api/insertDataMaterial.php', true);

    // //Send the proper header information along with the request
    // req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

    // req.onreadystatechange = function () {//Call a function when the state changes.
    //   if (req.readyState == XMLHttpRequest.DONE && req.status == 200) {
    //     // Request finished. Do processing here.
    //     req.onload = () => {
    //       console.log(JSON.parse(req.response));
    //       //JSON.parse(req.response);
    //     };
    //   }
    // }
    // req.send(this.data);
    // console.log('----data-----', this.data);
  
  
    //upload image
    if(this.myFile!=null){
      this.uploadPhoto(this.myFile);
    }
  

  this.router.navigateByUrl('default-layout/material');

  }

  
  uploadPhoto(file:File){
    var formData = new FormData();
    formData.append('file', file);
    var request = new XMLHttpRequest();
    request.open('POST', `${this.urlApi}`);
    request.send(formData);
  }

  attachFile(event) : void {
    var reader = new FileReader();
    let _self = this;

    reader.onload = function(e) {
      _self.imageSrc = reader.result;
      //console.log(_self.imageSrc);
    };
    reader.readAsDataURL(event.target.files[0]);
    this.myFile = event.target.files[0];
   //this.uploadPhoto(event.target.files[0]);
   //console.log('File name : ',this.myFile.name);
   }

  getCatalog(catalog){
    this.catalogStr = catalog;

  }

  getUnit(unit) {
    this.unitStr = unit;
  }
  getSource(source){
    this.sourceStr = source;
  }
  getColor(color) {
    this.colorStr = color;
  }
  getType(type) {
    this.typeStr = type;
  }
  getStatus(status) {
    this.statusStr = status;
  }


  ngOnInit() {
    this.colorStr = "N/A";
    this.sourceStr="N/A";
    this.unitStr = "Pcs";
    this.maxStr = "0";
    this.minStr = "0";
    this.priceStr = "0.00";
    this.lotsizeStr="0";
    this.lengthStr = "0";
    this.cuttingStr = "0";
    this.typeStr="N/A";
    this.weightStr="0";
  
    this.fetchSupplier((supplier) => {
      this.suppliers = supplier.map(function (val) {
        return [val.tb2_company_shortname]
      });
      //console.log('------this.supplier------', this.suppliers);
    });

    this.fetchPartno((partno) => {
      this.partnos = partno.map(function (val) {
        return [val.tm_part_no]
      });
      //console.log('------this.partnos------', this.partnos);
    });

      this.fetchCatalog((dataCatalog)=>{
          this.catalogs = dataCatalog;
      });
        
    this.stateCtrl = new FormControl();
    this.filteredStates = this.stateCtrl.valueChanges
      .startWith(null)
      .map(name => this.filterStates(name));


     this.form = this.fb.group({
      //stateCtrl: [null, Validators.compose([Validators.required])],
      model: [null, Validators.compose([Validators.required])],
      partname: [null, Validators.compose([Validators.required])],
      partno: [null, Validators.compose([Validators.required])],
      max: [null, Validators.compose([Validators.required])],
      min: [null, Validators.compose([Validators.required])],
      type: [null, Validators.compose([Validators.required])],
      spec: [null, Validators.compose([Validators.required])],
      price: [null, Validators.compose([Validators.required])],
      lotsize: [null, Validators.compose([Validators.required])],
      weight:[null, Validators.compose([Validators.required])],
      cutting:[null, Validators.compose([Validators.required])],
      length:[null, Validators.compose([Validators.required])],
      file:[null, Validators.compose([Validators.required])]
      //color: [null, Validators.compose([Validators.required])],
      // unit: [null, Validators.compose([Validators.required])]
      //email: [null, Validators.compose([Validators.required, CustomValidators.email])],
      //range: [null, Validators.compose([Validators.required, CustomValidators.range([5, 9])])],
      //url: [null, Validators.compose([Validators.required, CustomValidators.url])],
      //date: [null, Validators.compose([Validators.required, CustomValidators.date])],
      //creditCard: [null, Validators.compose([Validators.required, CustomValidators.creditCard])],
      //phone: [null, Validators.compose([Validators.required, CustomValidators.phone('en-US')])],
      //gender: [null, Validators.required],
      //password: password,
      //confirmPassword: confirmPassword
      

    });
  }

  
}

//dialog
@Component({
  selector: 'material-dialog-exist',
  templateUrl: 'material-dialog-exist.html',
})
export class MaterailDiableDialogExist {
  //Message = 'What would you like to do?';
  Message = '';
  Title='';
  constructor(public dialogRef: MdDialogRef<MaterailDiableDialogExist>) {}
}

//dialog
@Component({
  selector: 'material-dialog',
  templateUrl: 'material-dialog.html',
})
export class MaterailDiableDialogAdd {
  Message = 'What would you like to do?';
  constructor(public dialogRef: MdDialogRef<MaterailDiableDialogAdd>) {}
}



// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/material/material-form-add.ts